import React, { useState } from "react";
import logo from "../../assets/img/logo.jpeg";
import { baseurl } from "../../baseurl";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

/* ── all class names prefixed with "rp__" ── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=Inter:wght@400;500;600&display=swap');

@keyframes rp__spin   { to { transform: rotate(360deg); } }
@keyframes rp__floatA { 0%,100% { transform: translateY(0px) scale(1); }   50% { transform: translateY(-18px) scale(1.04); } }
@keyframes rp__floatB { 0%,100% { transform: translateY(0px) scale(1); }   50% { transform: translateY(14px) scale(0.97); } }
@keyframes rp__floatC { 0%,100% { transform: translate(0,0); }             50% { transform: translate(10px,-12px); } }
@keyframes rp__fadeUp { from { opacity:0; transform:translateY(28px); } to { opacity:1; transform:translateY(0); } }
@keyframes rp__pulse  { 0%,100% { box-shadow: 0 0 0 0 rgba(10,85,86,0.4); } 70% { box-shadow: 0 0 0 9px rgba(10,85,86,0); } }
@keyframes rp__shimmer {
  0%   { background-position: -400px 0; }
  100% { background-position:  400px 0; }
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

.rp__root {
  min-height: 100vh;
  display: flex;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  background: #eef6f6;
  position: relative;
  overflow: hidden;
}

/* ── blobs ── */
.rp__blob { position: fixed; border-radius: 50%; pointer-events: none; }
.rp__blob--1 {
  width: 500px; height: 500px; top: -170px; left: -170px;
  background: radial-gradient(circle, rgba(10,85,86,0.20) 0%, transparent 68%);
  animation: rp__floatA 8s ease-in-out infinite;
}
.rp__blob--2 {
  width: 440px; height: 440px; bottom: -130px; right: -110px;
  background: radial-gradient(circle, rgba(20,184,166,0.17) 0%, transparent 68%);
  animation: rp__floatB 10s ease-in-out infinite;
}
.rp__blob--3 {
  width: 310px; height: 310px; top: 38%; left: 40%;
  background: radial-gradient(circle, rgba(10,85,86,0.10) 0%, transparent 70%);
  animation: rp__floatC 12s ease-in-out infinite;
}
.rp__blob--4 {
  width: 200px; height: 200px; top: 8%; right: 30%;
  background: radial-gradient(circle, rgba(255,209,102,0.20) 0%, transparent 70%);
  animation: rp__floatB 9s ease-in-out infinite;
}

/* subtle grid */
.rp__grid {
  position: fixed; inset: 0; pointer-events: none;
  background-image:
    linear-gradient(rgba(10,85,86,0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(10,85,86,0.04) 1px, transparent 1px);
  background-size: 52px 52px;
}

/* ── left panel ── */
.rp__panel {
  flex: 1.15;
  display: flex; flex-direction: column;
  justify-content: center; align-items: flex-start;
  padding: 72px 60px; gap: 26px;
  position: relative; z-index: 1;
}

.rp__panel-badge {
  display: inline-flex; align-items: center; gap: 8px;
  background: rgba(10,85,86,0.08);
  border: 1px solid rgba(10,85,86,0.22);
  border-radius: 50px; padding: 8px 18px;
  font-family: 'Sora', sans-serif;
  font-size: 11.5px; font-weight: 700; color: #0a5556;
  letter-spacing: 0.08em; text-transform: uppercase;
  animation: rp__fadeUp 0.6s ease both;
}
.rp__panel-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: #0a5556; animation: rp__pulse 2s infinite;
}

.rp__panel-heading {
  font-family: 'Sora', sans-serif;
  font-size: clamp(28px, 3.4vw, 46px);
  font-weight: 800; color: #062020;
  line-height: 1.18; letter-spacing: -0.04em; max-width: 400px;
  animation: rp__fadeUp 0.65s 0.1s ease both;
}
.rp__panel-accent {
  color: #0a5556; position: relative; display: inline-block;
}
.rp__panel-accent::after {
  content: '';
  position: absolute; bottom: 1px; left: 0;
  width: 100%; height: 3px;
  background: linear-gradient(90deg, #0a5556, #14b8a6);
  border-radius: 2px;
}

.rp__panel-sub {
  font-size: 15px; color: #3d6060; max-width: 340px;
  line-height: 1.78; animation: rp__fadeUp 0.65s 0.18s ease both;
}

/* steps */
.rp__steps {
  display: flex; flex-direction: column; gap: 14px;
  animation: rp__fadeUp 0.65s 0.26s ease both;
}
.rp__step {
  display: flex; align-items: flex-start; gap: 16px;
  background: rgba(255,255,255,0.74); backdrop-filter: blur(14px);
  border: 1px solid rgba(10,85,86,0.13);
  border-radius: 16px; padding: 14px 20px;
  box-shadow: 0 2px 14px rgba(10,85,86,0.07);
  transition: transform 0.22s, box-shadow 0.22s;
  cursor: default;
}
.rp__step:hover { transform: translateX(7px); box-shadow: 0 6px 26px rgba(10,85,86,0.14); }
.rp__step-num {
  width: 36px; height: 36px; border-radius: 10px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  font-family: 'Sora', sans-serif; font-size: 14px; font-weight: 800; color: #fff;
  background: linear-gradient(135deg, #0a5556 0%, #14b8a6 100%);
  box-shadow: 0 4px 14px rgba(10,85,86,0.30);
}
.rp__step-body {}
.rp__step-title { font-size: 13.5px; font-weight: 700; color: #132b2b; margin-bottom: 2px; }
.rp__step-sub   { font-size: 12px; color: #6b8a8a; }

/* stats */
.rp__stats { display: flex; gap: 28px; animation: rp__fadeUp 0.65s 0.34s ease both; }
.rp__stat  { display: flex; flex-direction: column; gap: 3px; }
.rp__stat-val {
  font-family: 'Sora', sans-serif; font-size: 27px; font-weight: 800;
  color: #0a5556; line-height: 1; letter-spacing: -0.03em;
}
.rp__stat-label { font-size: 11.5px; color: #6b8a8a; font-weight: 500; }
.rp__stat-sep { width: 1px; background: rgba(10,85,86,0.16); align-self: stretch; }

/* ── right ── */
.rp__right {
  flex: 1; display: flex; align-items: center;
  justify-content: center; padding: 40px 32px;
  position: relative; z-index: 1;
}

/* ── card ── */
.rp__card {
  width: 100%; max-width: 460px;
  background: rgba(255,255,255,0.90); backdrop-filter: blur(30px);
  border-radius: 32px;
  border: 1px solid rgba(255,255,255,0.88);
  box-shadow:
    0 0 0 1px rgba(10,85,86,0.06),
    0 8px 32px rgba(10,85,86,0.08),
    0 32px 80px rgba(0,0,0,0.11),
    inset 0 1px 0 #fff;
  padding: 44px 44px 38px;
  animation: rp__fadeUp 0.75s 0.15s ease both;
  position: relative; overflow: hidden;
}
.rp__card::before {
  content: '';
  position: absolute; top: 0; left: 0; right: 0; height: 4px;
  background: linear-gradient(90deg, #0a5556 0%, #14b8a6 55%, #FFD166 100%);
  border-radius: 32px 32px 0 0;
}

/* logo */
.rp__logo-wrap { display: flex; justify-content: center; margin-bottom: 22px; }
.rp__logo-ring {
  padding: 4px; border-radius: 24px;
  background: linear-gradient(135deg, #0a5556, #14b8a6);
  box-shadow: 0 8px 30px rgba(10,85,86,0.32);
}
.rp__logo-img {
  width: 100%; height: 58px; display: block;
  border-radius: 20px; object-fit: cover;
  border: 3px solid #fff;
}

.rp__card-title {
  font-family: 'Sora', sans-serif;
  font-size: 23px; font-weight: 800;
  color: #062020; text-align: center;
  margin-bottom: 6px; letter-spacing: -0.03em;
}
.rp__card-sub {
  font-size: 13px; color: #6b8a8a;
  text-align: center; margin-bottom: 26px; line-height: 1.62;
}

/* label */
.rp__lbl {
  display: flex; align-items: center; gap: 6px;
  font-size: 11.5px; font-weight: 700; color: #132b2b;
  margin-bottom: 7px; letter-spacing: 0.06em; text-transform: uppercase;
}
.rp__lbl-dot { width: 5px; height: 5px; border-radius: 50%; background: #0a5556; }

/* fields */
.rp__field { position: relative; margin-bottom: 16px; }
.rp__input {
  width: 100%; padding: 13px 17px;
  font-size: 14px; font-family: 'Inter', sans-serif;
  color: #0a2020; background: #f3fafa;
  border: 1.5px solid #c8e4e4; border-radius: 13px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
.rp__input:focus {
  border-color: #0a5556; background: #fff;
  box-shadow: 0 0 0 4px rgba(10,85,86,0.11);
}
.rp__input::placeholder { color: #9ababa; }
.rp__input--pw { padding-right: 48px; }

.rp__eye {
  position: absolute; right: 13px; top: 50%; transform: translateY(-50%);
  background: none; border: none; cursor: pointer;
  color: #9ababa; font-size: 16px; padding: 4px;
  transition: color 0.2s;
}
.rp__eye:hover { color: #0a5556; }

/* 2-col grid */
.rp__grid2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

/* button */
.rp__btn {
  width: 100%; padding: 14px;
  font-size: 15px; font-family: 'Sora', sans-serif; font-weight: 700;
  color: #fff; letter-spacing: 0.04em;
  background: linear-gradient(135deg, #0a5556 0%, #0c7172 50%, #14b8a6 100%);
  background-size: 200% auto;
  border: none; border-radius: 14px; cursor: pointer;
  box-shadow: 0 6px 26px rgba(10,85,86,0.38);
  transition: background-position 0.4s, transform 0.15s, box-shadow 0.2s;
  position: relative; overflow: hidden; margin-top: 4px;
}
.rp__btn::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.14), transparent);
  background-size: 400px 100%; opacity: 0; transition: opacity 0.3s;
}
.rp__btn:hover { background-position: right center; transform: translateY(-2px); box-shadow: 0 12px 34px rgba(10,85,86,0.44); }
.rp__btn:hover::after { opacity: 1; animation: rp__shimmer 1.1s linear infinite; }
.rp__btn:active { transform: translateY(0); }
.rp__btn:disabled { opacity: 0.65; cursor: not-allowed; transform: none !important; }

/* spinner */
.rp__spin-icon {
  display: inline-block; width: 14px; height: 14px;
  border: 2px solid rgba(255,255,255,0.3); border-top-color: #fff;
  border-radius: 50%; animation: rp__spin 0.72s linear infinite;
  vertical-align: middle; margin-right: 9px;
}

/* divider */
.rp__div { display: flex; align-items: center; gap: 14px; margin: 20px 0 0; }
.rp__div-line { flex: 1; height: 1px; background: #c8e4e4; }
.rp__div-txt { font-size: 10.5px; font-weight: 700; color: #9ababa; letter-spacing: 0.12em; }

/* footer */
.rp__terms-link {
  display: block; text-align: center;
  font-size: 12px; color: #9ababa;
  margin: 16px 0 10px; text-decoration: underline; cursor: pointer;
}
.rp__terms-link:hover { color: #0a5556; }
.rp__footer { text-align: center; font-size: 13.5px; color: #6b8a8a; }
.rp__login-link { font-weight: 700; color: #0a5556; text-decoration: none; }
.rp__login-link:hover { text-decoration: underline; }

/* ── strength bar ── */
.rp__strength { margin-top: 7px; }
.rp__strength-track { height: 4px; border-radius: 50px; background: #c8e4e4; overflow: hidden; }
.rp__strength-bar { height: 100%; border-radius: 50px; transition: width 0.35s, background 0.35s; }
.rp__strength-label { font-size: 10.5px; font-weight: 600; margin-top: 4px; }

/* responsive */
@media (max-width: 860px) {
  .rp__panel { display: none !important; }
  .rp__right { padding: 28px 16px; }
  .rp__card { padding: 36px 24px 30px; border-radius: 24px; }
  .rp__grid2 { grid-template-columns: 1fr; }
}
`;

/* ── password strength helper ── */
function getStrength(pw) {
  if (!pw) return { score: 0, label: "", color: "" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  const map = [
    { label: "", color: "#c8e4e4", w: "0%" },
    { label: "Weak",   color: "#ef4444", w: "25%" },
    { label: "Fair",   color: "#f59e0b", w: "50%" },
    { label: "Good",   color: "#14b8a6", w: "75%" },
    { label: "Strong", color: "#10b981", w: "100%" },
  ];
  return map[score];
}

function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    business_name: "",
    name: "",
    email: "",
    password: "",
  });

  /* ── unchanged backend logic ── */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Sending Register Data:", formData);
    try {
      const res = await axios.post(`${baseurl}registerUser`, formData);
      console.log("Backend Response:", res.data);
      if (res.data.success) {
        localStorage.setItem("auth_token", res.data.token);
        localStorage.setItem("user", JSON.stringify(res.data.user));
        Swal.fire({
          toast: true, position: "top-end", icon: "success",
          title: res.data.message, showConfirmButton: false,
          timer: 3000, timerProgressBar: true,
        });
        setTimeout(() => { window.location.href = "/register-info"; }, 1500);
      }
    } catch (error) {
      console.error("Register Error:", error.response?.data || error.message);
      Swal.fire({
        toast: true, position: "top-end", icon: "error",
        title: error.response?.data?.message || "Registration failed",
        showConfirmButton: false, timer: 3000, timerProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const strength = getStrength(formData.password);

  return (
    <>
      <style>{CSS}</style>

      <div className="rp__root">
        {/* blobs + grid */}
        <div className="rp__blob rp__blob--1" />
        <div className="rp__blob rp__blob--2" />
        <div className="rp__blob rp__blob--3" />
        <div className="rp__blob rp__blob--4" />
        <div className="rp__grid" />

        {/* ══ LEFT PANEL ══ */}
        <div className="rp__panel">
          <div className="rp__panel-badge">
            <div className="rp__panel-dot" />
            Join 10,000+ Businesses
          </div>

          <h1 className="rp__panel-heading">
            Start managing your<br />finances with
            <br /><span className="rp__panel-accent">confidence</span>
          </h1>

          <p className="rp__panel-sub">
            Set up your account in under 2 minutes. No credit card required.
            Full GST-compliant invoicing from day one.
          </p>

          <div className="rp__steps">
            {[
              { n: "1", title: "Create your account",      sub: "Enter your business & personal details" },
              { n: "2", title: "Complete your profile",    sub: "Add GST, location & business type" },
              { n: "3", title: "Start invoicing",          sub: "Generate GST invoices immediately" },
            ].map((s) => (
              <div className="rp__step" key={s.n}>
                <div className="rp__step-num">{s.n}</div>
                <div className="rp__step-body">
                  <div className="rp__step-title">{s.title}</div>
                  <div className="rp__step-sub">{s.sub}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="rp__stats">
            <div className="rp__stat">
              <span className="rp__stat-val">10k+</span>
              <span className="rp__stat-label">Businesses</span>
            </div>
            <div className="rp__stat-sep" />
            <div className="rp__stat">
              <span className="rp__stat-val">₹500Cr+</span>
              <span className="rp__stat-label">Invoices processed</span>
            </div>
            <div className="rp__stat-sep" />
            <div className="rp__stat">
              <span className="rp__stat-val">4.8★</span>
              <span className="rp__stat-label">User rating</span>
            </div>
          </div>
        </div>

        {/* ══ RIGHT CARD ══ */}
        <div className="rp__right">
          <div className="rp__card">

            <div className="rp__logo-wrap">
              <div className="rp__logo-ring">
                <img src={logo} alt="logo" className="rp__logo-img" />
              </div>
            </div>

            <h2 className="rp__card-title">Create Your Account</h2>
            <p className="rp__card-sub">
              Register your business and start using our invoicing system.
            </p>

            <form onSubmit={handleSubmit} autoComplete="off">

              {/* Row 1: Business Name + Full Name */}
              <div className="rp__grid2">
                <div>
                  <div className="rp__lbl"><div className="rp__lbl-dot" />Business Name</div>
                  <div className="rp__field">
                    <input
                      type="text" name="business_name" className="rp__input"
                      placeholder="Acme Pvt Ltd"
                      value={formData.business_name}
                      onChange={handleChange} required
                    />
                  </div>
                </div>
                <div>
                  <div className="rp__lbl"><div className="rp__lbl-dot" />Your Name</div>
                  <div className="rp__field">
                    <input
                      type="text" name="name" className="rp__input"
                      placeholder="Full name"
                      value={formData.name}
                      onChange={handleChange} required
                    />
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="rp__lbl"><div className="rp__lbl-dot" />Email Address</div>
              <div className="rp__field">
                <input
                  type="email" name="email" className="rp__input"
                  placeholder="you@company.com"
                  value={formData.email}
                  onChange={handleChange} required
                />
              </div>

              {/* Password */}
              <div className="rp__lbl"><div className="rp__lbl-dot" />Password</div>
              <div className="rp__field">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password" className="rp__input rp__input--pw"
                  placeholder="Create a strong password"
                  value={formData.password}
                  onChange={handleChange} required
                />
                <button
                  type="button" className="rp__eye"
                  onClick={() => setShowPassword(!showPassword)} tabIndex={-1}
                >
                  <i className={showPassword ? "bi bi-eye-fill" : "bi bi-eye-slash-fill"} />
                </button>
              </div>

              {/* Password strength bar */}
              {formData.password && (
                <div className="rp__strength" style={{ marginBottom: 16, marginTop: -8 }}>
                  <div className="rp__strength-track">
                    <div className="rp__strength-bar" style={{ width: strength.w, background: strength.color }} />
                  </div>
                  <div className="rp__strength-label" style={{ color: strength.color }}>{strength.label}</div>
                </div>
              )}

              <button type="submit" className="rp__btn" disabled={loading}>
                {loading
                  ? <><span className="rp__spin-icon" />Creating account…</>
                  : "Create Account →"
                }
              </button>
            </form>

            <div className="rp__div">
              <div className="rp__div-line" />
              <span className="rp__div-txt">SECURE REGISTRATION</span>
              <div className="rp__div-line" />
            </div>

            <a href="#" className="rp__terms-link">Terms of Service &amp; Privacy Policy</a>

            <p className="rp__footer">
              Already have an account?{" "}
              <Link to="/" className="rp__login-link">Sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
